<div style="overflow: hidden;">
    <table class="text" style=" width:100%;">
        <th></th>
        <tr>
            <td> Status: </td>
            <td>
                <mat-radio-group [disabled]="!isEditable()" name="radioButtons1" [(ngModel)]="isActive" (change)="onStatusChange()" >
                    <mat-radio-button color="primary" id="explicitRadio" [value]="true">Aktiv</mat-radio-button>
                    <mat-radio-button color="primary" id="implicitRadio" [value]="false">Inaktiv</mat-radio-button>
                </mat-radio-group>
            </td>
            <td>Ændret: </td>
            <td>{{particularRow.changedDate}} af {{particularRow.changedBy}}</td>
        </tr>
        <tr>
            <td> InfRef: </td>
            <td>{{particularRow.key.infRef.infRefName}}</td>
            <td>Integration: </td>
            <td>
                {{ particularRow.sfNumber ? particularRow.sfNumber : '' }} <br/>
                {{ particularRow.integrationName ? particularRow.integrationName : '' }}
            </td>
        </tr>
        <tr>
            <td> Type: </td>
            <td>{{ particularRow.key.infRef.routingType }}</td>
            <td>Services: </td>
            <td>
            {{particularRow.sendingServiceName}}<br/>
            {{particularRow.receivingServiceName}}
            </td>
        </tr>
        <tr>
            <td> RuteId: </td>
            <td>{{particularRow.uuid}}</td>
        </tr>
               
        <tr>
            <td> Afsender: </td>
            <td colspan="3">
                <div class="senderDiv">
                    <app-route-sender-data [authority]="particularRow.key.senderAuthority"
                        [itSystem]="particularRow.key.senderItSystem"></app-route-sender-data>
                </div>
            </td>
        </tr>
        <tr>
            <td> Modtager: </td>
            <td colspan="3">
                <div class="senderDiv">
                    <app-route-sender-data [authority]="particularRow.key.recipientAuthority"
                        [itSystem]="particularRow.key.recipientItSystem"></app-route-sender-data>
                </div>
            </td>
        </tr>
        <tr>
            <td> Ruteperioder:<span class="mandatory">*</span> </td>
            <td colspan="3">
                <div style="margin-top: 20px">
                    <p-table #dt id="tb_id" [rows]="15" [value]="dateArray" [rowHover]="false" dataKey="id"
                        [showFirstLastIcon]="false">

                        <ng-template pTemplate="body" let-prod let-rowIndex="rowIndex">
        <tr [pSelectableRow]="prod">
            <td style="width: 10px">Fra:</td>
            <td>
                <span class="p-inputgroup">
                    <p-calendar [disabled]="!isEditable()" [ngModelOptions]="{standalone: true}"
                        id="changedDatePicker" [className]="'calendarInput'" appendTo="body"
                        [(ngModel)]="prod.validFrom" name="Gyldig-Fra" dateFormat="yy-mm-dd" inputId="min-max"
                        [showIcon]="true" [monthNavigator]="true" [showClear]="true" [yearNavigator]="true"
                        yearRange="2018:2040">
                    </p-calendar>
                    <app-popover-btn title="Gyldig fra"
                        text="Vælg første dato i periode, hvor ruten kan benyttes til overførsler. Hvis der ikke står en dato i feltet, er der ikke angivet en fra-dato, og perioden vil ikke være begrænset bagud i tid. Hvis ruten indeholder flere perioder, må disse ikke overlappe - dvs. fra-dato skal ligge senere end til-dato på en eventuelt foregående periode."></app-popover-btn>
                </span>
            </td>
            <td style="width: 10px">
                Til:
            </td>
            <td colspan="2">
                <span class="p-inputgroup">
                    <p-calendar [disabled]="!isEditable()" [(ngModel)]="prod.validTo" id="changedDatePicker"
                        [className]="'calendarInput'" appendTo="body" [minDate]="prod.validFrom" name="Gyldig-Fra"
                        dateFormat="yy-mm-dd" inputId="min-max" [showIcon]="true" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="2018:2040" [showClear]="true">
                    </p-calendar>
                    <app-popover-btn title="Gyldig til"
                        text="Vælg sidste dato i periode, hvor ruten kan benyttes til overførsler. Hvis der ikke står en dato i feltet, er der ikke angivet en til-dato, og perioden vil ikke være begrænset frem i tid. Hvis ruten indeholder flere perioder, må disse ikke overlappe - dvs. til-dato skal ligge før fra-dato på en eventuelt efterfølgende periode."></app-popover-btn>
                </span>
            </td>
            <td style="padding: 0px" *ngIf="isEditable()">
                <button (click)="deleteClicked(rowIndex)" pButton style="color: black;
                background: white;
                border: white;
                box-shadow: none;" icon="pi pi-trash"></button>
            </td>
        </tr>
        </ng-template>
        </p-table>
</div>
</td>
</tr>
<tr>
    <td>
    </td>
    <td colpan="3" *ngIf="isEditable()">
        <div>
            <button pButton id="newInrefbutton" class="addBound" (click)="addNewBound()">
                <mat-icon>add</mat-icon>Tilføj ruteperiode</button>
        </div>
    </td>
</tr>
</table>
<div>
    <span>
        <button [disabled]="!isEditable()" pButton class="add-button" label="Gem" type="submit"
            (click)="submitClicked()" id="gemButton"></button>
    </span>

    <span>
        <button pButton label="Annuller" class="add-button secondary" (click)="cancelClick()"
            id="annullerbutton2"></button>

    </span>
</div>

</div>